export class AwsDynamoDbSnapshotProperties {
    'localSecondaryIndexes';
    'globalSecondaryIndexes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "localSecondaryIndexes",
            "baseName": "localSecondaryIndexes",
            "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner>",
            "format": ""
        },
        {
            "name": "globalSecondaryIndexes",
            "baseName": "globalSecondaryIndexes",
            "type": "Array<AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
